import { QuestionCircleIcon, ArrowChevronRightMiniIcon } from '@calendly/ui/components/icons'
import { Link } from '@calendly/ui/components/link'
import freeEmailDomains from 'free-email-domains'

import { VALID_MI_CALENDARS } from './constants'

export const TermsLink = ({ children }) => (
  <Link
    href="https://calendly.com/legal/customer-terms-conditions"
    target="_blank"
    rel="noopener noreferrer"
    underline={false}
    variant="subtle"
  >
    {children}
  </Link>
)

export const LearnMoreLinkMeetingRecaps = ({ children }) => (
  <Link
    href="https://help.calendly.com/hc/en-us/articles/21652725311383-Meeting-Recaps-overview#01JJPWAXY1TYNYSG2TZSV0HWFA"
    target="_blank"
    rel="noopener noreferrer"
    underline={false}
  >
    <QuestionCircleIcon />
    {children}
    <ArrowChevronRightMiniIcon />
  </Link>
)

export const UserSettingsLink = ({ children }) => (
  <Link
    href="/app/personal/ai_notetaker"
    target="_blank"
    rel="noopener noreferrer"
    underline={false}
  >
    {children}
  </Link>
)

export const handleCheckCalInvalid = (kind = '', isNotetakerOutlookSettingsEnabled = false) => {
  const validCalendars = [...VALID_MI_CALENDARS]
  if (isNotetakerOutlookSettingsEnabled) {
    validCalendars.push('outlook')
  }
  return validCalendars.includes(kind.toLowerCase())
}

export const handleDefaults = (e) => {
  e.stopPropagation()
  e.preventDefault()
}

export const handleCheckStepEnabled = (location, param) => new URLSearchParams(location.search).get(param) === 'true'

export const getPushCalendarData = (data) => {
  if (!Array.isArray(data) || !data.length) return false

  return data.find((cal) => cal?.email) || false
}

export const checkIsFreeEmailDomain = (email) => {
  if (typeof email !== 'string') return false
  const domain = email.split('@')[1]
  return domain ? freeEmailDomains.includes(domain) : false
}

const LOCATION_KIND_DISPLAY_NAMES = {
  ZOOM: 'Zoom',
  GOOGLE_MEET: 'Google Meet',
  MICROSOFT_TEAMS: 'Microsoft Teams',
  zoom_conference: 'Zoom',
  google_conference: 'Google Meet',
  microsoft_teams_conference: 'Microsoft Teams',
  zoom: 'Zoom',
  google_conferencing: 'Google Meet'
}

export const getLocationKindDisplayName = (event) => (
  LOCATION_KIND_DISPLAY_NAMES[event?.locationKind]
  ?? LOCATION_KIND_DISPLAY_NAMES[event?.locationType]
  ?? LOCATION_KIND_DISPLAY_NAMES[event?.location_kind]
  ?? null
)
